import { render } from "./SidebarItem.vue?vue&type=template&id=4ee48a88&scoped=true&ts=true"
import script from "./SidebarItem.vue?vue&type=script&lang=ts"
export * from "./SidebarItem.vue?vue&type=script&lang=ts"

import "./SidebarItem.vue?vue&type=style&index=0&id=4ee48a88&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee48a88"]])

export default __exports__